<template>
    <div class="d-inline-block">
        <div
            v-for="(c, i) in choices"
            :key="i"
            class="fade-up d-inline-block"
            :style="{ transitionDelay: (0.15 + 0.1 * i) + 's' }"
        >
            <b-btn
                class="btn-circle mr-3"
                :class="{'active': c === value}"
                size="lg"
                variant="outline-primary"
                @click="$emit('input', c)"
            >
                {{ $t(`common.buttons.${c.type}`) }}
            </b-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Choices',
    props: {
        choices: {
            type: Array,
            default: () => [],
        },
        // eslint-disable-next-line vue/require-default-prop
        value: [Object, String, Number],
    },
};
</script>
